
define('app/board/views/shareView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueInstanceModel',
], function($, _, Backbone, LeagueInstanceModel){
	var ShareView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstanceModel = options.lgInstanceModel;
			
			$(".shareTrigger").on("click", function(event){
				var width = $(document).width();
				var height = $(document).height();
				
				var popupRight = width - event.pageX;
				var popupTop = event.pageY + 15;
				
				if(popupRight > (width - 230)){
					popupRight = width - 230;
				}
				if(popupTop > (height -290)){
					popupTop = height -290;
				}
				
				$('#sharePopup .dropdown-menu').css('top', popupTop);
				$('#sharePopup .dropdown-menu').css('right', popupRight);
			});
		},
		
		render: function () {
			//Setup social links
			var fantTypeText = 'fantasy';
			
			switch (this.lgInstanceModel.get('prodLeagueName')) {
			case 'NFL':
				fantTypeText += ' football';
				break;
			case 'MLB':
				fantTypeText += ' baseball';
				break;
			case 'NBA':
				fantTypeText += ' basketball';
				break;
			case 'NHL':
				fantTypeText += ' hockey';
				break;
			default:
				break;
			}
			var facebookLink = 
				'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fclickydraft.com%2Fdraftapp%2Fboard%2F'
				+ this.lgInstanceModel.get("id");		
			var twitterLink = 
				'https://twitter.com/share?url=https%3A%2F%2Fclickydraft.com%2Fdraftapp%2Fboard%2F'
				+ this.lgInstanceModel.get("id")
				+ '&via=ClickySports&text='
				+ encodeURIComponent('Watch our live ' + fantTypeText + ' draft board: ');		
			$('#sharePopup .socialBtnTwitter').attr("href", twitterLink);
			$('#sharePopup .socialBtnFacebook').attr("href", facebookLink);
			
			return this;
		},
	});
	
	return ShareView;  
});